import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'convertComment',
	standalone: true,
})
export class ConvertCommentPipe implements PipeTransform {
	transform(comment: string): string {
		return this.convertComment(comment);
	}

	private convertComment(comment: string): string {
		const convertedComment = comment
			.replaceAll('<p>', '')
			.replaceAll('</p>', '')
			.replaceAll('&bull;', '')
			.replaceAll('&oacute;', 'ó');
		return convertedComment;
	}
}
